import React from 'react';

import { ColumnDefinition } from 'components/Grid/types';

import { ProtectorType } from 'core/constants';

// Related-tab/page columns, so the fields are the entity-field keys the entity endpoints emit —
// `documents__name`, not the Documents module's own folder/document list shape. A field that does
// not exist reads as `{ value: undefined }`, which rendered a blank Name and a "last modified" of
// the current time.
export const basicDocumentsColumns = [
  {
    field: 'documents__name',
    headerName: 'Name',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'type',
    headerName: 'Type',
    renderCell: ({ value }: { value: { value: 'folder' | 'document' } }): React.ReactNode =>
      value ? <p>{value.value.charAt(0).toUpperCase() + value.value.slice(1)}</p> : null,
  },
] as unknown as ColumnDefinition[];
